<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <button uilabMatButton="outlined" [uilabMatMenuTriggerFor]="basicMenu">
            Open menu
        </button>

        <uilab-mat-menu #basicMenu="uilabMatMenu">
            <button uilab-mat-menu-item>Refresh data</button>
            <button uilab-mat-menu-item>Duplicate view</button>
            <button uilab-mat-menu-item>Export CSV</button>
        </uilab-mat-menu>
    </avd-code-example>
}
